import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'
import { createCSSObject, colorToLunaToken } from '../../../helpers/theming/utilities'
import { LinkWrapper } from '../../../helpers/StyledWrappers.styles'

const sainsburysMargin = (props) => (props.hasIcon ? props.theme.size.spacing['2xl'] : 0)
const wrapperCSS = css`
  flex-direction: row;
  flex-wrap: wrap;
  text-decoration: none;
  position: relative;
  ${(props) =>
    css`
      height: ${props.theme.channel === 'sainsburys' ? 'unset' : '90px'};
      justify-content: ${props.theme.channel === 'sainsburys' ? 'flex-start' : 'center'};
      text-align: ${props.theme.channel === 'sainsburys' ? 'left' : 'center'};
      padding: ${props.theme.size.spacing.lg};
      margin-bottom: ${props.theme.size.spacing.lg};
      background-color: ${colorToLunaToken(props.backgroundColour, props.theme) ||
      props.theme.color.monochrome.lighter};
    `}
`

const WrapperAnchor = styled(Row)`
  ${wrapperCSS}
  ${LinkWrapper}
`

const WrapperDiv = styled(Row)`
  ${wrapperCSS}
`

const Headings = styled(Column)`
  color: ${(props) => colorToLunaToken(props.textColor, props.theme) || props.theme.color.monochrome.darker};
  display: flex;
  margin-bottom: 0;
  justify-content: center;
  align-items: ${(props) => (props.theme.channel === 'sainsburys' ? 'flex-start' : 'center')};
  flex-direction: column;

  ${(props) =>
    props.ctaExists &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        padding-left: ${props.theme.channel === 'sainsburys' ? '0' : '12%'};
      }
    `}

  h4,
  p {
    margin-bottom: 0;
  }

  h4 {
    ${(props) => props.theme.channel === 'sainsburys' && createCSSObject(props.theme.font.stack['label-2'])}
    margin-left: ${(props) => (props.hasIcon ? props.theme.size.spacing.md : 0)};
  }

  p {
    margin-left: ${(props) => (props.theme.channel === 'sainsburys' ? sainsburysMargin(props) : '0')};
  }
`

const Cta = styled(Column)`
  color: ${(props) => colorToLunaToken(props.textColor, props.theme) || props.theme.color.monochrome.darker};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: ${(props) => sainsburysMargin(props)};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    justify-content: flex-end;
    margin-left: 0;
  }
`

const CmsCta = styled.span`
  ${(props) =>
    css`
      font-weight: ${props.theme.font.weight.bold};
      text-decoration: ${props.theme.channel === 'sainsburys' ? 'underline' : 'none'};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        display: flex;
      }
    `}
`
const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export { WrapperAnchor, WrapperDiv, Headings, Cta, CmsCta, HeadingWrapper }
